<template>
  <div class="SuscripcionesPrecio">
    <div class="row">
      <div class="col-sm-11 col-md-10 col-center">
        <md-card>
          <md-card-header>
            <div class="md-title">Historial de precios</div>
          </md-card-header>
          <md-table v-model="precios" md-sort="desde_spr" md-sort-order="asc" md-fixed-header>
            <md-table-empty-state :md-label="mensaje_tabla" />
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="Desde" md-sort-by="desde_spr">{{ moment(item.desde_spr).format('lll') }}</md-table-cell>
              <md-table-cell md-label="Hasta" md-sort-by="hasta_spr">{{ item.hasta_spr === '0000-00-00 00:00:00' || item.hasta_spr === null ? 'Precio actual': moment(item.hasta_spr).format('lll') }}</md-table-cell>
              <md-table-cell md-label="6 meses" md-sort-by="seis_meses_spr">{{ nF(item.seis_meses_spr) }}</md-table-cell>
              <md-table-cell md-label="12 meses" md-sort-by="doce_meses_spr">{{ nF(item.doce_meses_spr) }}</md-table-cell>
              <md-table-cell md-label="Registró" md-sort-by="empleado">{{ item.empleado }}</md-table-cell>
            </md-table-row>
          </md-table>
          <md-card-actions>
            <md-button class="md-raised md-accent" @click.native="modal_actualizar_precio=true">Actualizar precio</md-button>
          </md-card-actions>
        </md-card>
      </div>
    </div>
    <md-dialog :md-active.sync="modal_actualizar_precio">
      <md-dialog-title>Actualizar precio</md-dialog-title>
      <md-dialog-content>
        <md-field :class="vp.seis_meses_spr">
          <label>Suscripción semestral</label>
          <md-input v-model="precio.seis_meses_spr" type="number" min="0" />
          <span class="md-error">Por favor corrija este campo</span>
        </md-field>
        <md-field :class="vp.doce_meses_spr">
          <label>Suscripción anual</label>
          <md-input v-model="precio.doce_meses_spr" type="number" min="0" />
          <span class="md-error">Por favor corrija este campo</span>
        </md-field>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button @click.native="modal_actualizar_precio = false">Cerrar</md-button>
        <md-button class="md-raised md-accent" @click.native="actualizarPrecio()">Actualizar precios</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import moment from "moment";
import "moment/locale/es";

export default {
  name: "SuscripcionesPrecio",
  methods: {
    nF(n) {
      return Intl.NumberFormat("es-MX", {
        style: "currency",
        currency: "MXN"
      }).format(n);
    },
    moment(a, b) {
      return moment(a, b);
    },
    obtenerPrecios() {
      this.mensaje_tabla = "Cargando el historial precios...";
      this.cargando_tabla = true;
      this.$http
        .post("precios/historial", {
          token: this.$session.get("token")
        })
        .then(
          response => {
            this.mensaje_tabla = "No se encontraron precios de suscripción";
            this.cargando_tabla = false;
            if (response.status === 200 && "precios" in response.body) {
              this.precios = response.body.precios;
            } else {
              this.$parent.sb.texto = response.body.error;
              this.$parent.sb.mostrar = true;
            }
          },
          response => {
            this.mensaje_tabla = "No se encontraron precios de suscripción";
            this.cargando_tabla = false;
            this.$parent.sb.texto =
              "No se pudo establecer conexión con el servidor para obtener el historial de precios";
            this.$parent.sb.mostrar = true;
          }
        );
    },
    actualizarPrecio() {
      if (this.validarPrecio()) {
        this.$http
          .post("precios/actualizar", {
            token: this.$session.get("token"),
            data: this.precio
          })
          .then(
            response => {
              if (response.status === 200 && "msg" in response.body) {
                this.obtenerPrecios();
                this.$parent.sb.texto = response.body.msg;
                this.modal_actualizar_precio = false;
              } else {
                this.$parent.sb.texto = response.body.error;
                this.$parent.sb.mostrar = true;
              }
            },
            response => {
              this.$parent.sb.texto =
                "No se pudo establecer conexión con el servidor para obtener el historial de precios";
              this.$parent.sb.mostrar = true;
            }
          );
      }
    },
    validarPrecio() {
      this.vp.seis_meses_spr =
        this.precio.seis_meses_spr > 0 ? false : "md-invalid";
      this.vp.doce_meses_spr =
        this.precio.doce_meses_spr > 0 ? false : "md-invalid";
      if (this.vp.seis_meses_spr || this.vp.doce_meses_spr) {
        this.$parent.sb.texto = "Por favor ingrese los precios correctamente.";
        this.$parent.sb.mostrar = true;
        return false;
      } else {
        return true;
      }
    }
  },
  watch: {
    modal_actualizar_precio: function(val) {
      this.precio.seis_meses_spr = null;
      this.precio.doce_meses_spr = null;
      this.vp.seis_meses_spr = null;
      this.vp.doce_meses_spr = null;
    }
  },
  data() {
    return {
      precios: [],
      precio: {
        seis_meses_spr: null,
        doce_meses_spr: null
      },
      vp: {
        seis_meses_spr: null,
        doce_meses_spr: null
      },
      error: null,
      modal_actualizar_precio: false,
      mensaje_tabla: "No se encontraron precios de suscripción",
      cargando_tabla: false
    };
  },
  beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push("/login");
    }
  },
  created() {
    this.obtenerPrecios();
  }
};
</script>